<template>
  <div class="fundingMethods  lg:px-0">
    <div class="fundingMethods-1 relative">
      <template v-if="!isMoblie">
        <img class=" absolute -right-2 top-9 w-40" src="@/assets/images/home/round.svg" alt="">
        <img class=" absolute right-40 top-9 w-20" src="@/assets/images/home/round.svg" alt="">
        <img class=" absolute left-9 bottom-9 w-20" src="@/assets/images/home/round.svg" alt="">
      </template>

      <div class="container mx-auto py-28 items-center">
        <div class="flex flex-col lg:px-80">
          <div class="text-main text-4xl text-center font-semibold">{{ overview.title }}</div>
          <div class="text-sub-title text-base text-center pt-8" v-html="overview.description"></div>
          <div class="text-center pt-10">
            <a :href="options.openTradingAccountLink">
              <el-button class="px-2 py-3 rounded-lg lg:px-4" type="danger">{{ options.openTradingAccountText
                }}</el-button>
            </a>
            <a :href="options.openDemoAccountLink" class="ml-2">
              <el-button class="px-2 py-3 rounded-lg lg:px-4">{{ options.openDemoAccountText }}</el-button>
            </a>
          </div>
        </div>
        <!-- <img class="m-auto mt-16" src="../../assets/images/account/top3.svg" /> -->
        <img class="m-auto mt-16" :src="$path + overview?.image?.data?.attributes?.url" />
      </div>
    </div>
    <div class="fundingMethods-2 px-2">
      <div class="pt-10 container mx-auto flex flex-col h-full lg:pt-16">
        <div class="text-main font-semibold text-2xl">{{ overview.titleSecond }}</div>
        <p class="pt-4 text-sub-title" v-html="overview.descriptionSecond"></p>
        <div class="flex flex-col items-center mt-20">
          <div class="choice-tabs h-11 inline-flex flex-row items-center rounded-md text-center">
            <div class="text-xs px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
              :class="active === 'deposit' ? 'primary_linear' : ''" @click="activeTab('deposit')">
              {{ $t('account.fundingMethods.fundingMethods2.tab1') }}
            </div>
            <div class="text-xs px-2 mx-2 font-medium lg:text-base cursor-pointer py-1 rounded-md"
              :class="active === 'withdrawal' ? 'primary_linear' : ''" @click="activeTab('withdrawal')">
              {{ $t('account.fundingMethods.fundingMethods2.tab2') }}
            </div>
          </div>
          <el-card shadow="always" class="rounded-2xl mt-10 lg:mt-24 w-full">
            <el-table v-if="translations.fundingMethod" class="mt-10" :data="newMethods"
              :size="xsShow ? 'mini' : 'large'" :header-row-style="{ color: '#101828', 'background-color': '#C1142A' }">
              <el-table-column :prop="item" align="center" :width="xsShow ? 120 : 'auto'" :label="getLabel(item)"
                v-for="item in overview.options?.method_fields_display" :key="item">
                <template slot-scope="scope">
                  <div class="text-center" v-if="overview.options?.image?.includes(item)">
                    <img class="inline-block" :src="$path + scope.row.image?.data?.attributes.url" />
                  </div>
                  <span>{{ scope.row[item] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <p class="text-menu-title font-semibold mt-6" v-if="active === 'deposit'">
              {{ $t('account.fundingMethods.fundingMethods2.notes') }}</p>
            <p class="text-sub-title mt-4"
              v-html="active === 'deposit' ? overview.noticeDeposit : overview.noticeWithdrawal"></p>

          </el-card>
        </div>
      </div>
    </div>
    <div class="fundingMethods-3 mt-20">
      <go-register></go-register>
    </div>
  </div>
</template>

<script>
import goRegister from '../global/goRegister'
import { mapGetters } from 'vuex'
import { getFundingMethod } from '@/api/account'
import { getMethodsList, getTranslations } from '@/api/index'

export default {
  name: 'Home',
  data() {
    return {
      active: 'deposit',
      xsShow: false, // 手机显示
      activeWidth: window.innerWidth,
      activeAry: ['1'],
      overview: {},
      methods: [],
      translations: {}
    }
  },
  watch: {
    activeWidth: {
      handler(val, oldVal) {
        if (val <= 416) {
          this.xsShow = true
        } else {
          this.xsShow = false
        }
      },
      deep: true, // true 深度监听
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      lang: 'getLang'
    }),
    lang() {
      return this.$store.state.lang
    },
    options() {
      return this.$store.getters.options
    },
    isMoblie() {
      return this.$store.getters.isMoblie
    },
    newMethods() {
      return this.methods.filter(v => v.category === this.active)
    }
  },
  components: { goRegister },
  created() {
    this.getFundingMethod()
    this.getMethodsList()
    this.getTranslations()
  },
  mounted() {
  },
  methods: {
    activeTab(tab) {
      this.active = tab
    },
    goDisclosureStatement() {
      this.$emit('goDisclosureStatement')
    },
    async getFundingMethod() {
      const params = {
        'populate[country][fields]': '*',
        'populate[image][fields]': 'url'
      }
      const result = await getFundingMethod(params)
      this.overview = result.data.attributes
    },
    async getMethodsList() {
      const params = {
        'populate[methods][populate][image][fields]': 'url',
      }
      const result = await getMethodsList(params)
      this.methods = result.data.attributes.methods
    },
    async getTranslations() {
      const result = await getTranslations()
      this.translations = result.data.attributes.translations
    },
    getLabel(value, type = 'account') {
      const account = this.translations.fundingMethod
      if (account) return account?.[value] || ''
    }
  }
}
</script>

<style lang="less" scoped>
.fundingMethods {
  background: #F9FAFB;

  .fundingMethods-1 {
    background-color: #fff;
    background-image: url("../../assets/images/home/advantage.svg");
    margin-bottom: 30px;
  }

  .fundingMethods-2 {
    background: url("../../assets/images/account/money.svg") no-repeat;
    background-size: 23%;
    background-position: right bottom;

    .choice-tabs {
      background: linear-gradient(0deg, #EAECF0, #EAECF0),
        linear-gradient(0deg, #F9FAFB, #F9FAFB);
    }

    /deep/ .el-table {
      th {
        background-color: #F9FAFB;
      }

      .cell {
        white-space: pre-line;
      }
    }
  }

  .fundingMethods-3 {}

  .fundingMethods-4 {
    background-image: url("../../assets/images/home/advantage.svg");

    ul {
      li {
        list-style-type: disc;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .fundingMethods {}
}
</style>
